import React from 'react';
import * as Icons from 'lucide-react';
import { ChevronsRight, Asterisk } from 'lucide-react';
import { approach } from '../data/mock';

const Approach = () => {
  return (
    <section className="relative py-20 lg:py-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 mb-14">
          <div>
            <div className="inline-flex items-center gap-2 text-sm font-medium text-[#C41E3A] mb-4">
              <Asterisk className="w-4 h-4" />
              Our Approach
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.5rem] font-extrabold text-neutral-900 leading-[1.05]">
              Essential features for modern compliance success
            </h2>
          </div>
          <div className="lg:pt-16">
            <p className="text-neutral-600 text-base md:text-lg leading-relaxed">
              We map every requirement by authority, certification type, testing route and renewal cycle — so your team can move from requirement to approved product with clarity.
            </p>
          </div>
        </div>

        {/* 3 cards - flex layout ensures aligned buttons */}
        <div className="grid md:grid-cols-3 gap-5">
          {approach.map((a, i) => {
            const Icon = Icons[a.icon] || Icons.Sparkles;
            const isPrimary = a.variant === 'primary';
            const isDark = a.variant === 'dark';
            return (
              <div
                key={i}
                className={`lift group relative rounded-[2rem] p-8 lg:p-10 overflow-hidden border flex flex-col min-h-[440px] ${
                  isPrimary
                    ? 'bg-[#C41E3A] border-[#C41E3A] text-white'
                    : isDark
                    ? 'bg-[#0A0E1A] border-[#0A0E1A] text-white'
                    : 'bg-white border-neutral-200 text-neutral-900'
                }`}
              >
                {/* Decorative circle */}
                <div className={`absolute -bottom-16 -right-16 w-56 h-56 rounded-full ${
                  isPrimary ? 'bg-white/10' : isDark ? 'bg-[#C41E3A]/20' : 'bg-rose-50'
                }`} />

                <div className={`relative w-16 h-16 rounded-2xl flex items-center justify-center mb-8 ${
                  isPrimary ? 'bg-white/15' : isDark ? 'bg-[#C41E3A]' : 'bg-rose-50'
                }`}>
                  <Icon className={`w-7 h-7 ${isPrimary ? 'text-white' : isDark ? 'text-white' : 'text-[#C41E3A]'}`} />
                </div>

                <h3 className="relative font-display text-2xl md:text-[28px] font-bold leading-tight mb-4 max-w-[260px]">
                  {a.title}
                </h3>
                <p className={`relative text-sm leading-relaxed max-w-[300px] ${
                  isPrimary ? 'text-white/85' : isDark ? 'text-white/70' : 'text-neutral-600'
                }`}>
                  {a.desc}
                </p>

                {/* Explore More pill - mt-auto pushes it to bottom for alignment */}
                <a
                  href="#services"
                  className={`pill-btn relative mt-auto pt-8 inline-flex items-center gap-2 rounded-full pl-4 pr-1 h-10 self-start text-xs font-semibold border ${
                    isPrimary
                      ? 'bg-white text-[#C41E3A] border-white'
                      : isDark
                      ? 'bg-[#C41E3A] text-white border-[#C41E3A]'
                      : 'bg-white text-neutral-900 border-neutral-900'
                  }`}
                  style={{ paddingTop: 0, marginTop: 'auto' }}
                >
                  <span className="inline-flex items-center gap-2">
                    Explore More
                    <span className={`w-7 h-7 rounded-full flex items-center justify-center pill-arrow ${
                      isPrimary ? 'bg-[#C41E3A] text-white' : isDark ? 'bg-white text-[#C41E3A]' : 'bg-neutral-900 text-white'
                    }`}>
                      <ChevronsRight className="w-3 h-3" />
                    </span>
                  </span>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Approach;
